import { render, staticRenderFns } from "./EventoPantalla.vue?vue&type=template&id=63b9f520&"
import script from "./EventoPantalla.vue?vue&type=script&lang=ts&"
export * from "./EventoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('63b9f520', component.options)
    } else {
      api.reload('63b9f520', component.options)
    }
    module.hot.accept("./EventoPantalla.vue?vue&type=template&id=63b9f520&", function () {
      api.rerender('63b9f520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Eventos/EventoPantalla.vue"
export default component.exports